export default "__VITE_ASSET__BfBKsi3g__"